import { Component } from "@angular/core";
import { setDefaultOptions } from "date-fns";
import { es } from "date-fns/locale";
import { PrimeNGConfig } from "primeng/api";
import { ConfigService } from "./core/endpoints/config.service";
import { CountryRest } from "./core/endpoints/models/country-rest.model";
import { ApiService } from "./core/services/api.service";
import { AuthenticationService } from "./core/services/authentication.service";
import { User } from "./core/endpoints/models/user.model";
import { Router } from "@angular/router";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
})
export class AppComponent {
	menuMode = "static";
	message: any = null;
	static countries: CountryRest[] = [];
	public lang: string;
	public user: User;

	constructor(
		private primengConfig: PrimeNGConfig,
		public auth: AuthenticationService,
		private apiService: ApiService,
		private router: Router
	) {}

	ngOnInit() {
		this.primengConfig.ripple = true;
		document.documentElement.style.fontSize = "14px";

		this.primengConfig.setTranslation({
			startsWith: "Inicia con",
			contains: "Contiene",
			notContains: "No contiene",
			endsWith: "Termina en",
			equals: "Igual",
			notEquals: "Diferente",
			noFilter: "No Filtrar",
			lt: "Menor que",
			lte: "Menor o igual a",
			gt: "Mayor que",
			gte: "Mayor o igual a",
			is: "Es",
			isNot: "No es",
			before: "Antes",
			after: "Despues",
			dateIs: "La fecha es",
			dateIsNot: "La fecha no es",
			dateBefore: "La fecha es anterior",
			dateAfter: "La fecha es despues",
			clear: "Limpiar",
			apply: "Aplicar",
			matchAll: "Coincide todo",
			matchAny: "Coincide con cualquiera",
			addRule: "Agregar Regla",
			removeRule: "Eliminar Regla",
			accept: "Si",
			reject: "No",
			choose: "Elegir",
			upload: "Subir",
			cancel: "Cancelar",
			dayNames: [
				"Domingo",
				"Lunes",
				"Martes",
				"Miércoles",
				"Jueves",
				"Viernes",
				"Sábado",
			],
			dayNamesShort: [
				"dom",
				"lunes",
				"martes",
				"miércoles",
				"jueves",
				"viernes",
				"sábado",
			],
			dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
			monthNames: [
				"enero",
				"febrero",
				"marzo",
				"abril",
				"mayo",
				"junio",
				"julio",
				"agosto",
				"septiembre",
				"octubre",
				"noviembre",
				" Diciembre",
			],
			monthNamesShort: [
				"enero",
				"febrero",
				"marzo",
				"abril",
				"mayo",
				"junio",
				"julio",
				"agosto",
				"septiembre",
				"octubre",
				"noviembre",
				" Dic",
			],
			dateFormat: "dd/mm/yy",
			firstDayOfWeek: 1,
			today: "Hoy",
			weekHeader: "Semana",
			weak: "Débil",
			medium: "Medio",
			strong: "Fuerte",
			passwordPrompt: "Ingrese una contraseña",
			emptyMessage: "No se encontraron resultados",
			emptyFilterMessage: "No se encontraron resultados",
		});
		setDefaultOptions({ locale: es });
	}
}
